import { render, staticRenderFns } from "./linkTougheningBatch.vue?vue&type=template&id=24fd03ec&"
import script from "./linkTougheningBatch.vue?vue&type=script&lang=js&"
export * from "./linkTougheningBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports